import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Button } from '@dojo/widgets/button';

import { publish } from '@holmescorp/pub-sub';
import { createNlsMiddleware, userstate } from '@holmescorp/lcc-state';

import css from '../../css/general.m.css';
import { CardProperties, ConditionalFilter } from '../../interfaces';
import { Card } from '../../widgets';

export interface GeneralCardProperties extends CardProperties<string> {
	type: 'event' | 'link';
	action: string;
	title: string;
	button_label?: string;
	subtitle?: string;
	classes?: string;
}

const ditabookNls = createNlsMiddleware('ditabook');

const factory = create({
	theme,
	ditabookNls,
	userstate
}).properties<GeneralCardProperties>();

export const GeneralCard = factory(({ id, properties, middleware: { theme, ditabookNls, userstate } }) => {
	const {
		nlsKey = '',
		mediaSrc = '',
		mediaTitle = '',
		type,
		action,
		title,
		subtitle = '',
		button_label = '',
		classes = '',
		ispromotedisabled = 'true',
		ispromotable = 'false',
		ispromoted = 'false'
	} = properties();
	const themeCss = theme.classes(css);

	const { get, path } = userstate;

	const {
		messages: { conditional_card_display_filters = '{}' }
	} = ditabookNls();

	let parsedFilters: { [key: string]: ConditionalFilter[] };
	try {
		parsedFilters = JSON.parse(conditional_card_display_filters);
	} catch (e) {
		parsedFilters = {};
	}

	const shouldDisplay = (key: string) => {
		if (key in parsedFilters === false) {
			return true;
		}

		const conditionalFilters = parsedFilters[key];

		return conditionalFilters.every((filter) => {
			const toolstate = get(path('toolstate', filter.lookupkey || ''));

			return toolstate[filter.filterby] && toolstate[filter.filterby] === filter.condition;
		});
	};

	return shouldDisplay(nlsKey)
		? v('div', { id, classes: [theme.variant(), themeCss.root, classes] }, [
				w(Card, { mediaSrc, mediaTitle, nlsKey, ispromotable, ispromotedisabled, ispromoted }, [
					{
						content: v('div', { classes: [themeCss.content] }, [
							v('div', { classes: [themeCss.title] }, [title]),
							v('div', { classes: [themeCss.subtitle] }, [subtitle]),
							v('div', { classes: [themeCss.actions] }, [
								w(
									Button,
									{
										onClick: () => {
											if (type === 'event') {
												publish(`${action}`);
											} else {
												window.open(action, '_blank');
											}
										},
										onDown: () => {
											if (type === 'event') {
												publish(`${action}`);
											} else {
												window.open(action, '_blank');
											}
										},
										aria: { label: `${button_label} ${title}` }
									},
									[
										{
											label: button_label
										}
									]
								)
							])
						])
					}
				])
		  ])
		: null;
});

export default GeneralCard;
